"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
/**
 * A component corresponding the the content rendered inside the callout of the keytip component.
 *
 * @export
 * @class KeytipContent
 * @extends {BaseComponent<IKeytipProps>}
 */
var KeytipContentBase = /** @class */ (function (_super) {
    tslib_1.__extends(KeytipContentBase, _super);
    function KeytipContentBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeytipContentBase.prototype.render = function () {
        var _a = this.props, content = _a.content, getStyles = _a.getStyles, theme = _a.theme, disabled = _a.disabled, visible = _a.visible;
        var getClassNames = Utilities_1.classNamesFunction();
        var classNames = getClassNames(getStyles, {
            theme: theme,
            disabled: disabled,
            visible: visible
        });
        return (React.createElement("div", { className: classNames.container },
            React.createElement("span", { className: classNames.root }, content)));
    };
    KeytipContentBase = tslib_1.__decorate([
        Utilities_1.customizable('KeytipContent', ['theme'])
    ], KeytipContentBase);
    return KeytipContentBase;
}(Utilities_1.BaseComponent));
exports.KeytipContentBase = KeytipContentBase;
//# sourceMappingURL=KeytipContent.base.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Keytip/KeytipContent.base.js
// module id = 1010
// module chunks = 0